import axios from '../helpers/axios';
import { setApplicationChangeProfile } from '../reducers/applicationChangeProfile';
import { deletedApplicationChangeProfile } from './api/applicationChangeProfile';
import { applicationChangeProfileConstants } from './constants';

const getErrorMessage = error => (
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  'Неизвестная ошибка'
);

export const getApplicationChangeProfile = (sortStatusOrder, sort) => {
  return async dispatch => {
    dispatch({ type: applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_REQUEST });

    try {
      const url = sort
        ? `applicationChangeProfile/get?sort=${sort}`
        : 'applicationChangeProfile/get';

      const res = await axios.get(url, {
        params: {
          sortStatusOrder,
        },
      });

      const applicationsChangeProfile = res.data?.applicationsChangeProfile || [];

      dispatch({
        type: applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_SUCCESS,
        payload: { applicationsChangeProfile },
      });

      return applicationsChangeProfile;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_FAILURE,
        payload: { message: getErrorMessage(error) },
      });
      return [];
    }
  };
};

export const deleteManyApplicationChangeProfile = payload => {
  return async dispatch => {
    try {
      dispatch({ type: applicationChangeProfileConstants.DELETE_MANY_REQUEST });
      const res = await axios.post('/applicationChangeProfile/deleteMany', payload);

      dispatch({
        type: applicationChangeProfileConstants.DELETE_MANY_SUCCESS,
        payload: res.data,
      });
      dispatch(getApplicationChangeProfile('all', 'updatedAtMinus'));
      return res.data;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.DELETE_MANY_FAILURE,
        payload: { message: getErrorMessage(error) },
      });
      return null;
    }
  };
};

export const updateApplicationChangeProfileStatus = payload => {
  return async dispatch => {
    try {
      dispatch({ type: applicationChangeProfileConstants.UPDATE_STATUS_REQUEST });
      const res = await axios.post('/applicationChangeProfile/updateStatus', payload);

      dispatch({
        type: applicationChangeProfileConstants.UPDATE_STATUS_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.UPDATE_STATUS_FAILURE,
        payload: { message: getErrorMessage(error) },
      });
      return null;
    }
  };
};

export const getApplicationChangeProfileById = id => {
  return async dispatch => {
    dispatch({ type: applicationChangeProfileConstants.GET_BY_ID_REQUEST });

    try {
      const res = await axios.get(`/applicationChangeProfile/getById/${id}`);
      const applicationsChangeProfile = res.data?.applicationsChangeProfile || null;

      dispatch({
        type: applicationChangeProfileConstants.GET_BY_ID_SUCCESS,
        payload: { applicationsChangeProfile },
      });

      return applicationsChangeProfile;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.GET_BY_ID_FAILURE,
        payload: { message: getErrorMessage(error) },
      });
      return null;
    }
  };
};

export const searchApplicationChangeProfile = search => {
  return async dispatch => {
    try {
      const response = await axios.get('/applicationChangeProfile/getApplicationsChangeProfile/search', {
        params: { search },
      });
      dispatch(setApplicationChangeProfile(response.data));
      return response.data;
    } catch (error) {
      dispatch({
        type: applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_FAILURE,
        payload: { message: getErrorMessage(error) },
      });
      return null;
    }
  };
};

export const deleteApplicationChangeProfileById = id => async dispatch => {
  try {
    const response = await deletedApplicationChangeProfile(id);
    dispatch({
      type: applicationChangeProfileConstants.DELETE_APPLICATION_CHANGE_PROFILE_BY_ID_SUCCESS,
      payload: id,
    });
    dispatch(getApplicationChangeProfile('all', 'updatedAtMinus'));
    return response?.data || true;
  } catch (error) {
    console.error('deleteApplicationChangeProfileById:', getErrorMessage(error));
    return null;
  }
};
